module.exports = __webpack_public_path__ + "img/cross.8e6eccf2.svg";